module.exports = __webpack_public_path__ + "assets/images/project/head/Naomi_Osaka2.jpg?v=16d45dbb";